module.exports = {
	"pull": {
		"errormsg": "Sorry, we are unable to proceed",
		"successmsg": "Pull is done successfully"
	},
	"clone": {
		"successmsg": "Clone is done successfully"
	},
	"push": {
		"errormsg": "Sorry, we are unable to proceed",
		"successmsg": "Push is done successfully"
	},
	"share": {
		"successmsg": "Share is done successfully",
		"people": [
			{
				"image": "images/share_to_legutierr.png",
				"image1": "images/add__item_no_img.png",
				"id": "legutierr",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_arg.png",
				"image1": "images/add__item_arg.png",
				"id": "args2323",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "eduardo@dbmonline.net",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "abid@cognam.com",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "ashrivastava@cognam.com",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "srawat@cognam.com",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "legutierr1",
				"link": "invite via email roman@dbmonline.net"
			},
			{
				"image": "images/share_to_no_img.png",
				"image1": "images/add__item_no_img.png",
				"id": "legutierr2",
				"link": "invite via email roman@dbmonline.net"
			}
		]
	},
	"transfer": {
		"successmsg": "Transfer is done successfully"
	},
	"snapshot": {
		"successmsg": "Snapshot is done successfully"
	},
	"install": {
		"successmsg": "Install is done successfully"
	},
	"updatesData": {
		"type": "Select",
		"signInpopup": true,
		"minutes": 0
	},
	"Select": {
		"edit": true,
		"push": true,
		"pull": true
	},
	"Auto Read Only": {
		"edit": false,
		"push": false,
		"pull": true
	},
	"Manual Read Only": {
		"edit": true,
		"push": true,
		"pull": true
	},
	"Manual Read-Write (default)": {
		"edit": true,
		"push": true,
		"pull": true
	},
	"Auto Push": {
		"edit": true,
		"push": true,
		"pull": true
	},
	"Auto Push force": {
		"edit": true,
		"push": true,
		"pull": true
	},
	"errorStack": {
		"signInError": false,
		"signUpError": false,
		"forgotUsernameError": false,
		"activeUserError": false
	},
	"messages": {}
};


/** WEBPACK FOOTER **
 ** ./html/stores/storeConfig.json
 **/